$(document).ready(function() {
		$('a[href^="#"]').not('a[href^="#tab1"], a[href^="#tab2"], a[href^="#tab3"]').click(function(event) {
			var id = $(this).attr("href");
			var offset = 0;
			var target = $(id).offset().top - offset;

			$('html, body').animate({scrollTop:target}, 800);
			event.preventDefault();
		});
	});

// 

// Original
		// $('a[href^="#"]').click(function(event) {


					